import { useNavigate, useParams } from "react-router-dom";
import Footer from "../components/Footer/FooterSection";
import Header from "../components/Header/HeaderSection";
import { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import '../styles/viewall.scss';
import Products from "../components/Products/ProductsSection";
import { Product } from "../interface/interfaces";
import { useNotification } from "../context/NotificationContext";
import { loadNewArrivals, loadBestSelling, loadFlashsales, loadRecommended } from "../api/requests";


const ViewAll = () => {
    const { type } = useParams()
    const navigate = useNavigate()
    const { notify } = useNotification()

    const [products, setProducts] = useState<Product[]>([])

    const [isLoading, setIsLoading] = useState(false)
    const [pageTitle, setPageTitle] = useState('')

    const [naviFilter, setNaviFilter] = useState({
        currentPage: 1,
        pageSize: 30,
    })

    const goToPage = (num: number) => {
        setNaviFilter((prev) => {
            return {
                ...prev,
                currentPage: num
            }
        })
    }


    const [paginationData, setPaginationData] = useState({
        page: 0,
        size: 0,
        total: 0,
        pages: 0
    })

    const loadProducts = async () => {
            try {

                setIsLoading(true)

                if (type === 'new') {

                    setPageTitle('New Arrivals')

                    let { products, pageInfo } = await loadNewArrivals(naviFilter.currentPage, naviFilter.pageSize)

                    setProducts(products)
                    setPaginationData(pageInfo)




                } else if (type === 'bestsellers') {

                    setPageTitle('Best Sellers')

                    let { products, pageInfo } = await loadBestSelling(naviFilter.currentPage, naviFilter.pageSize)

                    setProducts(products)

                    setPaginationData(pageInfo)

                } else if (type === 'recommended') {

                    setPageTitle('Recommended Items')

                    let { products, pageInfo } = await loadRecommended()

                    setProducts(products)
                    setPaginationData(pageInfo)

                } else if (type === 'flashsales') {
                    setPageTitle('Flash Sales')

                    let { products, pageInfo } = await loadFlashsales(naviFilter.currentPage, naviFilter.pageSize)

                    setProducts(products)
                    setPaginationData(pageInfo)

                } else if (type === 'deals') {
                    setPageTitle(`Today's best deals`)

                    let { products, pageInfo } = await loadFlashsales(naviFilter.currentPage, naviFilter.pageSize)

                    setProducts(products)
                    setPaginationData(pageInfo)
                }

            } catch (error: any) {
                notify.error(error.message)
            } finally {
                setIsLoading(false)
            }

        }

    useEffect(() => {
        loadProducts()
    // eslint-disable-next-line
    }, [naviFilter])



    const handlePageIncrement = (inc: number) => {
        if (!isLoading) {

            setNaviFilter((prev) => {
                return {
                    ...prev,
                    currentPage: prev.currentPage + inc
                }
            })

        }

    }

    return (
        <>
            <Header></Header>
            <div className='viewall content'>


                <div className='pagetitle'>
                    <div className='icon goback' onClick={() => navigate(-1)}></div>
                </div>


                <Products title={pageTitle} isLoading={isLoading} products={products} setProducts={setProducts} showFull={true}></Products>




                <div className="paginationDiv">

                    {(paginationData.page - 1) >= 1 && (<div className="eachP  previous" onClick={() => handlePageIncrement(-1)}>
                        <ArrowLeft size={18}></ArrowLeft>
                        <span>Previous</span>
                    </div>)}

                    <div className="pages">

                        {paginationData.pages >= 1 && (<div className={`eachP num ${paginationData.page === 1 ? 'activepnum' : ''}`} onClick={() => goToPage(1)}>1</div>)}


                        {paginationData.pages >= 2 && (<div className={`eachP num ${paginationData.page === 2 ? 'activepnum' : ''}`} onClick={() => goToPage(2)}>2</div>)}


                        {paginationData.pages >= 3 && (<div className={`eachP num ${paginationData.page === 3 ? 'activepnum' : ''}`} onClick={() => goToPage(3)}>3</div>)}


                        {paginationData.page > 3 && (<>

                            <div className="eachP num">...</div>

                            <div className={`eachP num activepnum`}>{paginationData.page}</div>
                        </>)}

                    </div>

                    {paginationData.page + 1 <= paginationData.pages && (<div className="eachP next" onClick={() => handlePageIncrement(+1)}>
                        <span>Next</span>
                        <ArrowRight size={18}></ArrowRight>
                    </div>)}

                </div>

            </div>
            <Footer></Footer>
        </>
    )

}

export default ViewAll;